$(document).ready(function(){
	$('.js-ocio-accordion').click(function(){
		$('.js-ocio-accordion').removeClass('expanded');
		$(this).toggleClass('expanded');
	});
	$('.page-id-284 .ocio-accordion li:first-child').addClass('expanded');
}); 
